<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-text-field
                :label="formattedLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :aria-label="formattedAriaLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :outlined="outlined"
                :append-icon="appendIcon"
                :value="value"
                :name="metadata.name"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                :placeholder="placeholder"
                validate-on-blur
                :disabled="disableNam || disabled"
                :maxlength="maxLength"
                counter
                :rules="[
                    !computedRequired || requiredField('appt.errors.nam'),
                    v => !v || getFormRule('nam')(v),
                    v => !v || getFormRule('validateNamAgainstNameAndBirthday')(v, NAMRelatedFieldsValue),
                    v => !v || getFormRule('isNotTemporaryNAM')(v)
                ]"
                data-testid="nam-input"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @input="debouncedInput"
            />
        </v-flex>
        <nam-expiration-sequential
            :disabled="disableNam"
            :other-metadata="otherMetadata"
            :outlined="outlined"
            :computed-required="computedRequired"
            @updateOtherMetadata="$emit('updateOtherMetadata', $event)"
        />
        <v-flex v-if="isOverride" xs12 style="margin-top: -20px; margin-bottom: 10px;">
            <v-checkbox
                v-model="confirmSkipNam"
                class="pt-0 pb-4"
                color="primary"
                :label="$t('appt.skipNAM')"
                :disabled="!!value"
                hide-details
                @change="skipNam"
            />
        </v-flex>
    </v-layout>
</template>
<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters, mapMutations } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { debounce, get, toUpper, filter, includes, map } from 'lodash';
import { ProfileIdentityState, MetadataEnum } from '@/enums';
import { authModule, maskNam } from '@/utils';
import NamExpirationSequential from '@/components/metadata/inputs/Nam/NamExpirationSequential/NamExpirationSequential';

export default {
    name: 'nam',
    mixins: [formRules, inputHelpers],
    components: {
        NamExpirationSequential,
    },
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
        isOverride: { type: Boolean, required: false, default: false },
        otherMetadata: { type: Array, required: true },
    },
    data() {
        return {
            debouncedInput: undefined,
            confirmSkipNam: false,
            disableNam: false,
        };
    },
    created() {
        this.debouncedInput = debounce(this.emitValue, 100);
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            getProfileIdentityState: 'metadataForm/getProfileIdentityState',
            getLoggedUser: `${authModule}/getLoggedUser`,
            getPatientDataToFillMetadataForm: 'metadataForm/getPatientDataToFillMetadataForm',
        }),
        appendIcon() {
            return this.withIcon ? 'far fa-id-card' : '';
        },
        computedRequired() {
            if (this.isOverride && this.confirmSkipNam) {
                return false;
            }
            return this.required || this.isOverride;
        },
        disabled() {
            return !!this.getLoggedUser &&
                !!get(this.getPatientDataToFillMetadataForm, 'nam', null) &&
                this.getProfileIdentityState === ProfileIdentityState.VALIDATED;
        },
        maxLength() {
            return this.metadata && this.metadata.rules && Number(this.metadata.rules.maxLength) + 2;
        },
        NAMRelatedFieldsValue() {
            return map(this.NAMRelatedFields, 'value');
        },
        NAMRelatedFields() {
            return filter(this.otherMetadata, (metadata) =>
                includes([MetadataEnum.FIRST_NAME, MetadataEnum.LAST_NAME, MetadataEnum.BIRTHDAY], metadata.metadata));
        },
    },
    methods: {
        ...mapMutations({
            setNam: 'metadataForm/SET_MASKED_NAM',
        }),
        emitValue(value) {
            this.$emit('update:value', maskNam(toUpper(value)));
        },
        skipNam(val) {
            this.disableNam = val;
        },
    },
};
</script>
